<template>
  <div>
    <h2>Statusboard</h2>
    <b-overlay :show="loading" rounded="sm">
      <b-card no-body>
        <b-row class="mt-3 px-3">
          <b-col cols="5">
            <b-form-group>
              <b-form-checkbox
                id="historicalProjects"
                v-model="showHistorical"
                name="historicalProjectsCheckbox"
              >
                Include historical projects
              </b-form-checkbox>
              <b-form-checkbox
                v-if="isOfdit"
                id="myProjects"
                v-model="showOnlyMyProjects"
                name="myProjectsCheckbox"
              >
                Limit to projects where I am the OFDIT lead
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-cols-sm="3"
              label-align="right"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          selectable
          stacked="lg"
          show-empty
          empty-filtered-text="No records match your search. 🤷🏽‍♂️"
          select-mode="single"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @row-selected="onRowSelected"
          @filtered="onFiltered"
          :filter="filter"
          :filter-included-fields="filterFields"
          :items="projects"
          :fields="fields"
          class="mt-3"
        >
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
  export default {
    name: 'GProject',
    data() {
      return {
        showHistorical: false,
        showOnlyMyProjects: false,
        sortBy: 'course',
        sortDesc: false,
        filter: null,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: false,
          },
          {
            key: 'course',
            sortable: true,
          },
          {
            key: 'developer_lastname',
            label: 'Developer',
            sortable: false,
          },
          {
            key: 'stage',
            sortable: true,
          },
          {
            key: 'tags',
            sortable: false,
          },
          {
            key: 'ofdit_lead',
            label: 'OFDIT lead',
            sortable: true,
          },
          {
            key: 'delivery_date',
            label: 'Delivery date',
            formatter: value => {
              return value.substring(0, 10)
            },
            sortable: true,
          },
          {
            key: 'target_launch_semester',
            sortable: true,
            label: 'Launch semester',
          },
        ],
        filterFields: [
          'id',
          'tags',
          'target_launch_semester',
          'stage',
          'program',
          'ofdit_lead',
          'cohort',
          'developer_lastname',
          'course',
        ],
      }
    },
    computed: {
      loading() {
        return this.$store.state.common.ui.loading
      },
      isOfdit() {
        return this.$store.getters.isOfdit
      },
      // Apply filters to projects and check if a project is stale
      // TODO: define stale more precisely
      // TODO: refactor the "stale" prcoessing code
      projects() {
        if (!this.showHistorical && !this.showOnlyMyProjects) {
          return this.$store.getters.activeProjects.map(project => {
            const deliveryDate = new Date(project.delivery_date)
            const today = new Date()
            if (today < deliveryDate) {
              return project
            } else {
              project._rowVariant = 'danger'
              return project
            }
          })
        } else if (this.showHistorical && !this.showOnlyMyProjects) {
          return this.$store.getters.allProjects
        } else if (!this.showHistorical && this.showOnlyMyProjects) {
          return this.$store.getters.allMyActiveProjects.map(project => {
            const deliveryDate = new Date(project.delivery_date)
            const today = new Date()
            if (today < deliveryDate) {
              return project
            } else {
              project._rowVariant = 'danger'
              return project
            }
          })
        } else {
          return this.$store.getters.allMyProjects
        }
      },
    },
    methods: {
      onRowSelected(row) {
        if (row[0] !== undefined) {
          this.$store.dispatch('setCurrentProject', { project: row[0] })
          this.$store.commit('displayDetails')
        }
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    },
    watch: {
      loading: function() {
        this.totalRows = this.$store.getters.activeProjects.length
      },
      projects: function() {
        this.totalRows = this.projects.length
      },
    },
  }
</script>
